// extracted by mini-css-extract-plugin
export default {"cafeListWrapper":"style_cafeListWrapper__70dxf","localFilter":"style_localFilter__GoXGF","list":"style_list__jpZ-T","cafeCard":"style_cafeCard__yw2fV"};